var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":_vm.handleClick}},[_c('i',{class:_vm.control.icon_class})])}
var staticRenderFns = []

export { render, staticRenderFns }